import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Inject, Injectable, InjectionToken } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { LocalStorageEnum } from '../models/enums/local-storage.enum';
import { LocalStorageService } from '../services/local-storage.service';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  readonly #localStorageService = inject(LocalStorageService);
  readonly #router = inject(Router);

  constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue);

    return next.handle(req).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.onSignOut();
        }
        return throwError(() => err);
      }),
      timeout(timeoutValueNumeric)
    );
  }

  onSignOut() {
    this.#localStorageService.delete(LocalStorageEnum.token);
    this.#localStorageService.delete(LocalStorageEnum.expiry_time);
    this.#localStorageService.delete(LocalStorageEnum.refresh_token);
    this.#localStorageService.delete(LocalStorageEnum.permissions);
    this.#localStorageService.delete(LocalStorageEnum.user);
    this.#router.navigate(['/login']);
  }
}
